import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'toKbps',
})
export class ToKbpsPipe implements PipeTransform {
  transform(bytesPerSecond: number | undefined): number {
    return toKbps(bytesPerSecond);
  }
}

export function toKbps(bytesPerSecond: number | undefined): number {
  if (!bytesPerSecond || bytesPerSecond <= 0) return 0;
  const mbps = bytesPerSecond / 1_000;
  return parseFloat(mbps.toFixed(2));
}
